<template>
  <div>
    <CardCadastro>
      <div slot="header">
        <h4 class="title">Gráfico Auditoria</h4>
      </div>

      <div
        slot="header_button"
        style="width: 99%; float: right; text-align: right"
        v-if="show_print_button"
      >
        <md-button
          type="button"
          class="md-round md-just-icon md-primary"
          style="text-align: center"
          v-on:click="call_print"
          v-bind:disabled="loading_print"
        >
          <md-icon>print</md-icon>
        </md-button>
      </div>
      <div slot="body">
        <div v-if="loading" class="md-layout">
          <div class="md-layout-item md-size-100 box-carregando">
            <md-progress-spinner
              :md-diameter="40"
              :md-stroke="4"
              md-mode="indeterminate"
            >Carregando..</md-progress-spinner>
          </div>
        </div>
        <div v-if="loading_print" class="md-layout">
          <div class="md-layout-item md-size-100 box-carregando">
            <md-progress-spinner
              :md-diameter="40"
              :md-stroke="4"
              md-mode="indeterminate"
            >Gerando impressão..</md-progress-spinner>
          </div>
        </div>
        <div v-if="grafico != null && grafico.data.length > 0 ">
          <div class="box-grafico" v-for="(item, index) in grafico.paginacao" :key="index">
            <bargroup
              :unidades="item.unidades"
              :data="grafico.data"
              :onAppeared="setImagemJpeg"
              :index="index"
              :titulo="grafico.titulo"
            ></bargroup>
          </div>
        </div>
      </div>
    </CardCadastro>
  </div>
</template>  
 <script>
import CardCadastro from "../../../components/CardCadastro";
import Util from "../../../library/Util";
import checkbox_list from "../../components/checkbox_list";
import serviceUnidade from "../../../services/EstabelecimentoService";
import serviceModelo from "../../../services/ModeloChecklistService";
import Api from "../../../library/Api";
import bargroup from "../../components/graficos/bargroup";
import mixin_user from "../../../library/mixin/user";
import serviceSerializator from "../../../services/SerializatorService";

import modal from "../../../components/Modal";
export default {
  mixins: [mixin_user],
  components: {
    modal: modal,
    bargroup: bargroup,
    CardCadastro: CardCadastro
  },
  props: {
    onClose: {
      type: Function,
      default() {
        return null;
      }
    },
    id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      grafico: null,
      show_modal: true,
      loading: true,
      loaded_grafico: true,
      images_jpeg: [],
      tipo_grafico: "inspecao_id",
      show_print_button: false,
      loading_print: false
    };
  },
  methods: {
    closeModal() {
      this.show_modal = false;
      if (this.onClose != null) {
        this.onClose();
      }
    },

    call_print() {
      let self = this;
      console.log("call print?");

      var json = {
        images_jpeg: this.images_jpeg,
        tabela: this.grafico.tabela,
        id: this.id,
        tipo: this.tipo_grafico,
        tipo_grafico: this.tipo_grafico,
        registro: this.grafico.registro
      };
      this.loading_print = true;

      var data = {
        data_value: JSON.stringify(json),
        variableName: "print",
        data_type: "grafico_unico"
      };

      serviceSerializator.salvar(data).then(function(response) {
        console.log(response.data);
        self.loading_print = false;
        if (response.data != null) {
          if (response.data.url != null) {
            window.open(response.data.url);
          }
        }
      });
    },

    setImagemJpeg(data, index) {
      let self = this;
      this.images_jpeg[index] = data;

      if (index == this.grafico.paginacao.length - 1) {
        setTimeout(function() {
          self.show_print_button = true;
        }, 1000);
      }
    },

    load_data() {
      var self = this;

      self.grafico = null;

      var data = {
        id: this.id,
        id_cliente: this.getGlobalUserProp("id_cliente"),
        tipo_grafico: this.tipo_grafico
      };

      self.loaded_grafico = true;
      self.loading = true;

      self.show_print_button = false;
      self.images_jpeg = [];
      console.log(data);
      Api.Call("graficos", "POST", data).then(function(response) {
        self.grafico = response.data;
        self.loading = false;
        self.loaded_grafico = true;
      });
    }
  },
  mounted() {
    if (this.id != null) {
      this.load_data();
    }
  }
};
</script> 